<div>
  <mat-card>
    <mat-card-content style="text-align: end;">
      <mat-hint style="color: red;">{{showStatus}} </mat-hint>
      @if (showDeactivateToggle && id.value) {
        <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked">Deactivate</mat-slide-toggle>
      }
      @if (showReactivateToggle && id.value) {
        <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked">Reactivate</mat-slide-toggle>
      }
    </mat-card-content>
    <form [formGroup]="mapChargeSegmentForm">
      <mat-card-content>
        @if (!id.value) {
          <mat-form-field appearance="fill">
            <mat-label>Copy From Previous Entry</mat-label>
            <mat-select (selectionChange)="previousValueChange()" formControlName="previousEntryId" placeholder="Copy From Previous Entry">
              <mat-option>
                <ngx-mat-select-search  [searching]="searching" [formControl]="previousEntrySearchCtrl"
                  noEntriesFoundLabel="'no matching found'" placeholderLabel="Copy From Previous Entry">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option value="0">None</mat-option>
              @for (p of filteredPreviousEntries |async; track p) {
                <mat-option [disabled]="p.status!='APPROVED'" [value]="p.parentId">
                  {{p.stateName}} ({{p.segmentName}})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          }<br>
          <mat-form-field appearance="fill">
            <mat-label>Select State</mat-label>
            <mat-select formControlName="stateId" placeholder="Select State" required>
              <mat-option>
                <ngx-mat-select-search  [searching]="searching" [formControl]="stateSearchCtrl"
                  noEntriesFoundLabel="'no matching found'" placeholderLabel="Search State">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="null">None</mat-option>
              @for (s of filteredStates |async; track s) {
                <mat-option [value]="s.id">
                  {{s.name}} ({{s.code}})
                </mat-option>
              }
            </mat-select>
            @if (stateId.touched && stateId.invalid && stateId.hasError('required')) {
              <mat-error>State is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Select Segment</mat-label>
            <mat-select formControlName="segmentId" placeholder="Select Segment" required>
              <mat-option>
                <ngx-mat-select-search  [searching]="searching" [formControl]="segmentSearchCtrl"
                  noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Segment">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="null">None</mat-option>
              @for (c of filteredSegments |async; track c) {
                <mat-option [value]="c.parentId">
                  {{c.name}} ({{c.code}})
                </mat-option>
              }
            </mat-select>
            @if (segmentId.touched && segmentId.invalid && segmentId.hasError('required')) {
              <mat-error>Segment is required</mat-error>
            }
          </mat-form-field>
        </mat-card-content>
        <mat-divider></mat-divider>
        <mat-card-content style="margin-top: 2%;">
          <h3>Map Charge to Business Segment</h3>
          <mat-button-toggle-group style="margin-top: 1%;">
            <mat-button-toggle (click)="onButtonToggleChange('showLocalIncomeDetails')">Local Income</mat-button-toggle>
            <mat-button-toggle (click)="onButtonToggleChange('showLocalExpenseDetails')">Local Expense</mat-button-toggle>
            <mat-button-toggle (click)="onButtonToggleChange('showOverseasIncomeDetails')">Overseas Income</mat-button-toggle>
            <mat-button-toggle (click)="onButtonToggleChange('showOverseasExpenseDetails')">Overseas Expense</mat-button-toggle>
            <mat-button-toggle (click)="onButtonToggleChange('showSezIncomeDetails')">Income from Sez</mat-button-toggle>
          </mat-button-toggle-group>
          <mat-card-content style="margin-top: 2%;"  [ngStyle]="{'display': showLocalIncomeDetails.value ? 'block':'none' }">
            <h4>Map Charges to Business Segment - Local Income</h4>
            <mat-form-field appearance="fill">
              <mat-label>Ledger</mat-label>
              <mat-select formControlName="localIncomeLedgerId" placeholder="Select Ledger">
                <mat-option>
                  <ngx-mat-select-search  [searching]="searching" [formControl]="ledgerSearchCtrl"
                    noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Ledger">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null">None</mat-option>
                @for (l of filteredLedgers | async; track l) {
                  <mat-option [value]="l.id">
                    {{l.name}} ({{l.code}})
                  </mat-option>
                }
              </mat-select>
              @if (localIncomeLedgerId.touched && localIncomeLedgerId.invalid && localIncomeLedgerId.hasError('required')) {
                <mat-error>Ledger is required</mat-error>
              }
            </mat-form-field>
            <app-map-segment-charge-detail #localIncomeDetails [patchValue]="resLocalIncomeDetails" [disableForm]="disableSubmit"></app-map-segment-charge-detail>
          </mat-card-content>
          <mat-card-content style="margin-top: 2%;"  [ngStyle]="{'display': showLocalExpenseDetails.value ? 'block':'none' }">
            <h4>Map Charges to Business Segment - Local Expenses</h4>
            <mat-form-field appearance="fill">
              <mat-label>Ledger</mat-label>
              <mat-select formControlName="localExpenseLedgerId" placeholder="Select Ledger">
                <mat-option>
                  <ngx-mat-select-search  [searching]="searching" [formControl]="ledgerSearchCtrl"
                    noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Ledger">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null">None</mat-option>
                @for (l of filteredLedgers | async; track l) {
                  <mat-option [value]="l.id">
                    {{l.name}} ({{l.code}})
                  </mat-option>
                }
              </mat-select>
              @if (localExpenseLedgerId.touched && localExpenseLedgerId.invalid && localExpenseLedgerId.hasError('required')) {
                <mat-error>Ledger is required</mat-error>
              }
            </mat-form-field>
            <app-map-segment-charge-detail #localExpenseDetails [patchValue]="resLocalExpenseDetails" [disableForm]="disableSubmit"></app-map-segment-charge-detail>
          </mat-card-content>
          <mat-card-content style="margin-top: 2%;"  [ngStyle]="{'display': showOverseasIncomeDetails.value ? 'block':'none' }">
            <h4>Map Charges to Business Segment - Overseas Income</h4>
            <mat-form-field appearance="fill">
              <mat-label>Ledger</mat-label>
              <mat-select formControlName="overseasIncomeLedgerId" placeholder="Select Ledger">
                <mat-option>
                  <ngx-mat-select-search  [searching]="searching" [formControl]="ledgerSearchCtrl"
                    noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Ledger">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null">None</mat-option>
                @for (l of filteredLedgers | async; track l) {
                  <mat-option [value]="l.id">
                    {{l.name}} ({{l.code}})
                  </mat-option>
                }
              </mat-select>
              @if (overseasIncomeLedgerId.touched && overseasIncomeLedgerId.invalid && overseasIncomeLedgerId.hasError('required')) {
                <mat-error>Ledger is required</mat-error>
              }
            </mat-form-field>
            <app-map-segment-charge-detail #overseasIncomeDetails [patchValue]="resOverseasIncomeDetails" [disableForm]="disableSubmit"></app-map-segment-charge-detail>
          </mat-card-content>
          <mat-card-content style="margin-top: 2%;"  [ngStyle]="{'display': showOverseasExpenseDetails.value ? 'block':'none' }">
            <h4>Map Charges to Business Segment - Overseas Expenses</h4>
            <mat-form-field appearance="fill">
              <mat-label>Ledger</mat-label>
              <mat-select formControlName="overseasExpenseLedgerId" placeholder="Select Ledger">
                <mat-option>
                  <ngx-mat-select-search  [searching]="searching" [formControl]="ledgerSearchCtrl"
                    noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Ledger">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null">None</mat-option>
                @for (l of filteredLedgers | async; track l) {
                  <mat-option [value]="l.id">
                    {{l.name}} ({{l.code}})
                  </mat-option>
                }
              </mat-select>
              @if (overseasExpenseLedgerId.touched && overseasExpenseLedgerId.invalid && overseasExpenseLedgerId.hasError('required')) {
                <mat-error>Ledger is required</mat-error>
              }
            </mat-form-field>
            <app-map-segment-charge-detail #overseasExpenseDetails [patchValue]="resOverseasExpenseDetails" [disableForm]="disableSubmit"></app-map-segment-charge-detail>
          </mat-card-content>
          <mat-card-content style="margin-top: 2%;"  [ngStyle]="{'display': showSezIncomeDetails.value ? 'block':'none' }">
            <h4>Map Charges to Business Segment - Income From SEZ</h4>
            <mat-form-field appearance="fill">
              <mat-label>Ledger</mat-label>
              <mat-select formControlName="sezIncomeLedgerId" placeholder="Select Ledger">
                <mat-option>
                  <ngx-mat-select-search  [searching]="searching" [formControl]="ledgerSearchCtrl"
                    noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Ledger">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null">None</mat-option>
                @for (l of filteredLedgers | async; track l) {
                  <mat-option [value]="l.id">
                    {{l.name}} ({{l.code}})
                  </mat-option>
                }
              </mat-select>
              @if (sezIncomeLedgerId.touched && sezIncomeLedgerId.invalid && sezIncomeLedgerId.hasError('required')) {
                <mat-error>Ledger is required</mat-error>
              }
            </mat-form-field>
            <div class="mat-elevation-z8 service-container">
              <mat-table formArrayName="sezIncomeDetails" [dataSource]="sezDetailsDataSource">
                <ng-container matColumnDef="chargeCode">
                  <mat-header-cell *matHeaderCellDef>Charge Code</mat-header-cell>
                  <mat-cell *matCellDef="let row;let i=index" [formGroupName]="i">
                    <mat-form-field appearance="fill">
                      <mat-select (selectionChange)="chargedChanged(row,i)"  formControlName="chargeId">
                        <mat-option>
                          <ngx-mat-select-search formControlName="chargeSearch" placeholderLabel="Search Charge"
                          noEntriesFoundLabel="No item found" ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option [value]="null">None</mat-option>
                        @for (c of row.get('chargeList').value; track c) {
                          <mat-option [disabled]="checkChargeDisableCondition(c)" [value]="c.parentId" >
                            {{ c.name }} ({{c.code}})
                          </mat-option>
                        }
                      </mat-select>
                      @if (sezIncomeDetails.controls[i].get('chargeId').errors?.required) {
                        <mat-error class="mt-1">
                          Required
                        </mat-error>
                      }
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="chargeName">
                  <mat-header-cell *matHeaderCellDef>Charge Name</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
                    <mat-form-field appearance="fill">
                      <input matInput formControlName="chargeName" autocomplete="off" readonly>
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="taxable">
                  <mat-header-cell *matHeaderCellDef>Taxable</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
                    <mat-form-field appearance="fill">
                      <mat-select formControlName="taxable" required>
                        @for (t of taxableList; track t) {
                          <mat-option [value]="t.key" >
                            {{ t.label }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (sezIncomeDetails.controls[i].get('taxable').errors?.required) {
                        <mat-error class="mt-1">
                          Required
                        </mat-error>
                      }
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="chargeTypeMechanism">
                  <mat-header-cell *matHeaderCellDef>Charge Mechanism</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
                    <mat-form-field appearance="fill">
                      <mat-select formControlName="chargeTypeMechanism" required>
                        <mat-option [value]="null">None</mat-option>
                        @for (d of chargeTypeMechanismList; track d) {
                          <mat-option [value]="d.key" >
                            {{ d.label }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (sezIncomeDetails.controls[i].get('chargeTypeMechanism').errors?.required) {
                        <mat-error class="mt-1">
                          Required
                        </mat-error>
                      }
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="sacCode">
                  <mat-header-cell *matHeaderCellDef>SAC Code</mat-header-cell>
                  <mat-cell *matCellDef="let row;let i=index" [formGroupName]="i">
                    <mat-form-field appearance="fill">
                      <mat-select (selectionChange)="sacChanged(row,i)" formControlName="sacId" required>
                        <mat-option>
                          <ngx-mat-select-search formControlName="sacSearch" placeholderLabel="Search SAC"
                          noEntriesFoundLabel="No item found" ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option [value]="null">None</mat-option>
                        @for (s of row.get('sacList').value; track s) {
                          <mat-option [value]="s.id" >
                            {{s.code}}
                          </mat-option>
                        }
                      </mat-select>
                      @if (sezIncomeDetails.controls[i].get('sacId').errors?.required) {
                        <mat-error class="mt-1">
                          Required
                        </mat-error>
                      }
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="sacName">
                  <mat-header-cell *matHeaderCellDef>SAC Name</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
                    <mat-form-field appearance="fill">
                      <input matInput formControlName="sacName" autocomplete="off" readonly>
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="igst">
                  <mat-header-cell *matHeaderCellDef>IGST %</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
                    <mat-form-field appearance="fill">
                      <input matInput formControlName="igst" autocomplete="off" required>
                      @if (sezIncomeDetails.controls[i].get('igst').errors?.required) {
                        <mat-error class="mt-1">
                          Required
                        </mat-error>
                      }
                      @if (sezIncomeDetails.controls[i].get('igst').errors?.pattern) {
                        <mat-error class="mt-1">
                          Enter valid IGST
                        </mat-error>
                      }
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="gstWef">
                  <mat-header-cell *matHeaderCellDef> Gst WEF </mat-header-cell>
                  <mat-cell *matCellDef="let row;let i=index" [formGroupName]="i">
                    <mat-form-field appearance="fill" style="margin-bottom: 14%;">
                      <input (dateChange)="dateChangeEvent($event,row)" matInput [matDatepicker]="picker" formControlName="gstWef" required autocomplete="off" readonly>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      @if (sezIncomeDetails.controls[i].get('gstWef').errors?.required) {
                        <mat-error class="mt-1">
                          Required
                        </mat-error>
                      }
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="deactivated">
                  <mat-header-cell *matHeaderCellDef>Deactivated</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
                    @if (row.get('id').value) {
                      <mat-checkbox (change)="deactivateChanged(row,$event)" class="ser-icon" formControlName="deactivated"></mat-checkbox>
                    }
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="updateGst">
                  <mat-header-cell *matHeaderCellDef>Update GST Rates</mat-header-cell>
                  <mat-cell class="__action_row" *matCellDef="let row; let i=index">
                    @if (!row.get('deactivated').value && row.get('id').value) {
                      <span class="__action_edit_icon" (click)="openGstEditForm(row.get('chargeId').value)" style="margin-right: 10px;">
                        <mat-icon>create</mat-icon>
                      </span>
                    }
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="action">
                  <mat-header-cell *matHeaderCellDef>Action
                    @if (!sezIncomeDetails.length) {
                      <button mat-icon-button (click)="addChargeField()" matTooltip="Add Charge Detail">
                        <mat-icon>add_circle</mat-icon>
                      </button>
                    }
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index;">
                    @if (!row.get('id').value) {
                      <span class="__action_delete_icon" (click)="removeChargeField(i)" matTooltip="Remove this Charge Detail">
                        <mat-icon>delete_forever</mat-icon>
                      </span>
                    }
                    <span style="margin-left: 10px;" class="__action_add_icon" (click)="addChargeField(row)" matTooltip="Add Charge Detail">
                      <mat-icon mat-cell>add_circle</mat-icon>
                    </span>
                  </mat-cell>
                  <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="sezDetailColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: sezDetailColumns" [class.hidden]="!row.get('show').value"></mat-row>
              </mat-table>
            </div>
          </mat-card-content>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button color="primary" [disabled]="disableSubmit || (!editPermission && id.value) || (!addPermission && !id.value)" (click)="onSave()" style="width: 10%;margin-right: 10px;">Save</button>
          <button mat-button color="cancel" (click)="onCancel()" style="width: 10%;">Cancel</button>
        </mat-card-actions>
        <mat-card-content style="margin-top: 1%">
          @if (id.value) {
            <div class="audit-log">
              <button mat-stroked-button type="button" [class.active]="viewLog.value"
                  (click)="viewLog.setValue(!viewLog.value)">
                  <mat-icon>history</mat-icon> View Log
              </button>
            </div>
          }
          @if (viewLog.value) {
            <app-history [referenceType]="'MAP_CHARGE_TO_BUSINESS_SEGMENT'" [referenceId]="id.value"></app-history>
          }
        </mat-card-content>
      </form>
    </mat-card>
  </div>
